export const ACTIVATE_MOBILE_SERVICE_URL = '/activate/mobile/:orderId';
export const ACTIVATE_DATA_SERVICE_URL = '/activate/data/:orderId';

export const REGISTER_SESSION_KEYS = {
  PROSPECT_EMAIL: 'prospectEmail',
  PROSPECT_STATUS: 'prospectStatus'
} as const;
